import { NotificationConfiguration } from '../notification.templates';

export const CR_SHARE_CIRCULAR_RESOLUTION_TEMPLATE: NotificationConfiguration = {
  inapp: `<b>{triggeredByName}</b> shared a circular resolution with you.`,
  email: {
    ctaKey: 'go_to_cr',
  },
};
